<template>
  <div class="bjtjfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="拆单日期">
              <el-date-picker v-model="searchForm.time" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" type="daterange"
                :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getData">搜索</el-button>
              <el-button icon="el-icon-printer" style="margin-left: 10px;" size="small" :loading="excelLoading"
                @click="exportExcelAll">导出Excel</el-button>
            </el-form-item>
          </el-form>

          <div
            style="font-size: 13px; color:#F56C6C; background-color: #fef0f0; border-radius: 5px; padding: 12px 20px; margin-bottom: 20px;">
            <i class="el-icon-info" style="font-size: 16px;" />
            <b style="margin-left: 4px; font-size: 16px;">注意事项</b><br />
            总拆单金额中减去历史上已报过价的部分，如：某订单在2025年2月完成拆单及报价，2025年4月再次进行拆单就不会统计进去。
          </div>

          <div class="card-content">
            <el-row :gutter="20" style="padding-top: 12px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  新增拆单金额组成统计：共 {{ analysisData.financeTotal || 0 }} 元
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="analysisData.financeList" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="组成" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="拆单金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="拆单金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8" v-if="circleOption.finance">
                <GraphicsChart id="circle1" :option="circleOption.finance" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  拆单人员业绩统计：共 {{ analysisData.clientcom || 0 }} 元
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="analysisData.splitList" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="拆单员" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="拆单金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="拆单金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-view" @click="seeSplitDetail(scope.row)">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8" v-if="circleOption.split">
                <GraphicsChart id="circle2" :option="circleOption.split" />
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  订单拆单数量统计：共 {{ analysisData.totalNum || 0 }} 单，
                  其中已报价 {{ analysisData.ybjTotalNum || 0 }} 单，未报价
                  {{ (analysisData.totalNum || 0) - (analysisData.ybjTotalNum || 0) }} 单
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="analysisData.orderTypes" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="订单类型" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="订单数量">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF;">{{ scope.row.priceTotal }}</span><br />
                      <span v-if="scope.row.name === '正单'" style="font-size: 12px; color:#F56C6C;">
                        (已报价 {{ analysisData.zdBjNum || 0 }} 单，未报价
                        {{ scope.row.priceTotal - (analysisData.zdBjNum || 0) }} 单)
                      </span>
                      <span v-if="scope.row.name === '客改单'" style="font-size: 12px; color:#F56C6C;">
                        (已报价 {{ analysisData.kgdBjNum || 0 }} 单，未报价
                        {{ scope.row.priceTotal - (analysisData.kgdBjNum || 0) }} 单)
                      </span>
                      <span v-if="scope.row.name === '增补单'" style="font-size: 12px; color:#F56C6C;">
                        (已报价 {{ analysisData.zbdBjNum || 0 }} 单，未报价
                        {{ scope.row.priceTotal - (analysisData.zbdBjNum || 0) }} 单)
                      </span>
                      <span v-if="scope.row.name === '色板单'" style="font-size: 12px; color:#F56C6C;">
                        (已报价 {{ analysisData.sbdBjNum || 0 }} 单，未报价
                        {{ scope.row.priceTotal - (analysisData.sbdBjNum || 0) }} 单)
                      </span>
                      <span v-if="scope.row.name === '售后单'" style="font-size: 12px; color:#F56C6C;">
                        (已报价 {{ analysisData.shdBjNum || 0 }} 单，未报价
                        {{ scope.row.priceTotal - (analysisData.shdBjNum || 0) }} 单)
                      </span>
                      <span v-if="scope.row.name === '更改单'" style="font-size: 12px; color:#F56C6C;">
                        (已报价 {{ analysisData.ggdBjNum || 0 }} 单，未报价
                        {{ scope.row.priceTotal - (analysisData.ggdBjNum || 0) }} 单)
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="数量占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8" v-if="circleOption.orderType">
                <GraphicsChart id="circle3" :option="circleOption.orderType" />
              </el-col>
            </el-row>

            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  未报价订单列表：共 {{ analysisData.wbjList ? analysisData.wbjList.length : 0 }} 单
                </div>
              </el-col>

              <el-col :span="24" style="padding-top: 10px">
                <el-table :data="analysisData.wbjList" v-loading="loading" stripe max-height="400px"
                  :default-sort="{prop: 'orderType', order: 'descending'}" style="width: 100%">
                  <el-table-column type="index" width="50"></el-table-column>
                  <el-table-column prop="orderType" label="订单类型" align="center" sortable min-width="100">
                  </el-table-column>
                  <el-table-column prop="orderNum" align="center" label="订单号" sortable min-width="140">
                  </el-table-column>
                  <el-table-column prop="dealerName" align="center" label="经销商" sortable min-width="160">
                  </el-table-column>
                  <el-table-column prop="splitname" align="center" label="拆单员" sortable width="140">
                  </el-table-column>
                  <el-table-column prop="splittime" align="center" label="拆单时间" sortable min-width="180">
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <div
              style="font-size: 13px; color:#F56C6C; background-color: #fef0f0; border-radius: 5px; padding: 12px 20px; margin-top: 20px;">
              <i class="el-icon-info" style="font-size: 16px;" />
              <b style="margin-left: 4px; font-size: 16px;">注意事项</b><br />
              拆单时长以分配时间时间到最后一次拆单时间为准，如：某订单在3月1号分配至拆单，3号拆单完成，4号审单驳回当日再次拆单，将会按照1~4号的天数进行统计。
            </div>

            <el-row :gutter="20" style="padding-top: 12px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  订单正单拆单时长统计：共 {{ analysisData.zNum || 0 }} 单
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="analysisData.zCdDays" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="时长" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="订单数量">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="数量占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8" v-if="circleOption.zCd">
                <GraphicsChart id="circle4" :option="circleOption.zCd" />
              </el-col>
            </el-row>

            <el-row :gutter="20" style="padding-top: 12px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  订单补单拆单时长统计：共 {{ analysisData.bNum || 0 }} 单
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="analysisData.bCdDays" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="时长" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="订单数量">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="数量占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8" v-if="circleOption.bCd">
                <GraphicsChart id="circle5" :option="circleOption.bCd" />
              </el-col>
            </el-row>

            <el-row :gutter="20" style="padding-top: 12px; margin-bottom: 40px;">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  订单拆单时长明细列表：共 {{ analysisData.totalNum || 0 }} 单
                </div>
              </el-col>
              <el-col :span="24" style="padding-top: 10px">
                <el-table :data="analysisData.splitDetail" v-loading="loading" stripe max-height="400px"
                  :default-sort="{prop: 'orderType', order: 'descending'}" style="width: 100%">
                  <el-table-column type="index" width="50"></el-table-column>
                  <el-table-column prop="orderType" label="订单类型" align="center" sortable min-width="100">
                  </el-table-column>
                  <el-table-column prop="orderNum" align="center" label="订单号" sortable min-width="140">
                  </el-table-column>
                  <el-table-column prop="dealerName" align="center" label="经销商" sortable min-width="140">
                  </el-table-column>
                  <el-table-column prop="totalprice" align="center" label="订单总金额" sortable min-width="120">
                    <template slot-scope="scope">
                      <span v-if="scope.row.totalprice" style="font-weight: 500;color:#409EFF">{{ scope.row.totalprice }}</span>
                      <span v-else>--</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="splitname" align="center" label="拆单员" sortable width="120">
                  </el-table-column>
                  <el-table-column prop="splitStart" align="center" label="拆单开始时间" sortable
                    :sort-method="splitStartSort" min-width="160">
                    <template slot-scope="scope">
                      <span>{{ scope.row.splitStart || scope.row.allotTime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="splittime" align="center" label="拆单完成时间" sortable min-width="160">
                  </el-table-column>
                  <el-table-column prop="splitStandardTime" align="center" label="拆单标准时长" sortable
                    :sort-method="splitStandardSort" min-width="130">
                  </el-table-column>
                  <el-table-column prop="splitTake" align="center" label="拆单耗时" sortable :sort-method="splitTakeSort"
                    min-width="140">
                    <template slot-scope="scope">
                      <span>{{ scope.row.splitTakeTime && scope.row.splitTakeTime != '0秒' ? scope.row.splitTakeTime : scope.row.splitTake }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="splitPauseTake" align="center" label="暂停时长" :sort-method="splitPauseSort"
                    sortable min-width="140">
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>

            <el-row :gutter="20" style="padding-top: 12px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  订单正单拆单分配时长统计：共 {{ analysisData.zfNum || 0 }} 单
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="analysisData.zfCdDays" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="时长" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="订单数量">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="数量占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8" v-if="circleOption.zfCd">
                <GraphicsChart id="circle6" :option="circleOption.zfCd" />
              </el-col>
            </el-row>

            <el-row :gutter="20" style="padding-top: 12px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  订单补单拆单分配时长统计：共 {{ analysisData.bfNum || 0 }} 单
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="analysisData.bfCdDays" v-loading="loading" stripe style="width: 100%">
                  <el-table-column prop="name" label="时长" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="订单数量">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="数量占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8" v-if="circleOption.bfCd">
                <GraphicsChart id="circle7" :option="circleOption.bfCd" />
              </el-col>
            </el-row>

            <el-row :gutter="20" style="padding-top: 10px; margin-top: 40px; border-top: 1px solid #ebeef5;">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  订单正单拆单部数据汇总表
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="splitData.tableData" v-loading="loading2" stripe style="width: 100%" :cell-class-name="tableCellClassName">
                  <el-table-column prop="name" label="订单状态" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="num" align="center" label="数量">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="priceTotal" align="center" label="金额(元)">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.mark" size="mini" icon="el-icon-view" @click="seeOrders(scope.row)">查看订单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8" v-if="circleOption.sd">
                <GraphicsChart id="circle7" :option="circleOption.sd" />
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>
    </el-row>

    <el-dialog :title="viewTitle" :visible.sync="orderVisible" width="85%" top="10vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding:10px 20px">
        <el-table
          :data="orderList"
          size="small"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%;border:1px solid #EBEEF5;"
          height="442">
          <el-table-column
            label="订单号"
            min-width="110"
            align="center"
            fixed
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF">{{scope.row.orderNum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="生产单号"
            width="100"
            fixed
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF" v-if="scope.row.productNum!==null&&scope.row.productNum!==''&&scope.row.productNum!==undefined">{{scope.row.productNum}}</span>
              <span style="font-weight: 500;color:#999999" v-if="scope.row.productNum===null||scope.row.productNum===''||scope.row.productNum===undefined">N/A</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="orderTime"
            label="下单时间"
            align="center"
            min-width="150">
          </el-table-column>
          <el-table-column
            prop="dealerName"
            label="经销商"
            align="center"
            min-width="120"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="订单类型"
            width="80"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.type===1">客改单</span>
              <span v-else-if="scope.row.type===2">增补单</span>
              <span v-else-if="scope.row.type===3">色板单</span>
              <span v-else-if="scope.row.type===4">售后单</span>
              <span v-else>正单</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="qrTime"
            label="确认时间"
            align="center"
            min-width="150">
          </el-table-column>
          <el-table-column
            label="拆单人员"
            align="center"
            width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.splitname!==''&&scope.row.splitname!==null">{{ scope.row.splitname }}</span>
              <span v-if="scope.row.splitname===''||scope.row.splitname===null" style="color: #99a9bf;">N/A</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="splitTime"
            label="拆单时间"
            align="center"
            min-width="150">
          </el-table-column>
          <el-table-column
            label="审单人员"
            align="center"
            width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.reviewer!==''&&scope.row.reviewer!==null">{{ scope.row.reviewer }}</span>
              <span v-if="scope.row.reviewer===''||scope.row.reviewer===null" style="color: #99a9bf;">N/A</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="reviewTime"
            label="审单时间"
            align="center"
            min-width="150">
          </el-table-column>
          <el-table-column
            label="报价人员"
            align="center"
            width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.offername!==''&&scope.row.offername!==null">{{ scope.row.offername }}</span>
              <span v-if="scope.row.offername===''||scope.row.offername===null" style="color: #99a9bf;">N/A</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="bjTime"
            label="报价时间"
            align="center"
            min-width="150">
          </el-table-column>
          <el-table-column
            prop="address"
            label="详细地址"
            min-width="250"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog :title="viewTitle2" :visible.sync="orderVisible2" width="85%" top="10vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding:10px 20px">
        <el-table
          :data="orderList2"
          v-loading="orderLoading2"
          size="small"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%;border:1px solid #EBEEF5;"
          height="442">
          <el-table-column
            label="订单号"
            width="110"
            align="center"
            fixed
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF">{{scope.row.orderNum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="生产单号"
            width="100"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF" v-if="scope.row.prodNum">{{scope.row.prodNum}}</span>
              <span style="font-weight: 500;color:#999999" v-else>N/A</span>
            </template>
          </el-table-column>
          <el-table-column
            label="经销商"
            width="100"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span :style="scope.row.dealerName && scope.row.dealerName.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                {{ scope.row.dealerName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单类型"
            width="80"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.orderType }}</span>
            </template>
          </el-table-column>
          <<!-- el-table-column prop="totalprice" align="center" label="总金额" sortable width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.totalprice" style="font-weight: 500;color:#409EFF">{{ scope.row.totalprice }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="clientcom" align="center" label="客户承担" sortable width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.clientcom" style="font-weight: 500;color:#409EFF">{{ scope.row.clientcom }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="splitname" align="center" label="拆单员" width="100">
          </el-table-column>
          <el-table-column prop="splitStart" align="center" label="拆单开始时间" sortable
            :sort-method="splitStartSort" min-width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.splitStart || scope.row.allotTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="splittime" align="center" label="拆单完成时间" sortable min-width="160">
          </el-table-column>
          <el-table-column prop="splitTake" align="center" label="拆单耗时" sortable :sort-method="splitTakeSort"
            min-width="140">
            <template slot-scope="scope">
              <span>{{ scope.row.splitTakeTime && scope.row.splitTakeTime != '0秒' ? scope.row.splitTakeTime : scope.row.splitTake }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="splitPauseTake" align="center" label="暂停时长" :sort-method="splitPauseSort"
            sortable min-width="140">
          </el-table-column>
          <el-table-column prop="splitStandardTime" align="center" label="拆单标准时长" sortable
            :sort-method="splitStandardSort" min-width="130">
          </el-table-column>
          <el-table-column
            label="详细地址"
            min-width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.address }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
    getUser
  } from '@/utils/auth'

  import {
    getSplitAnalysis,
    getSplitAnalysisDetail,
    excelSplitAnalysis,
    getSplitData
  } from '@/api/erp'

  import axios from 'axios'

  import GraphicsChart from '@/components/Charts/GraphicsChart'

  export default {
    name: 'cdtjfx',
    components: {
      GraphicsChart
    },
    data() {
      return {
        loading: false,
        analysisData: {},

        loading2: false,
        splitData: {},

        viewTitle: '',
        orderLoading: false,
        orderVisible: false,
        orderList: [],

        viewTitle2: '',
        orderLoading2: false,
        orderVisible2: false,
        orderList2: [],

        excelLoading: false,
        searchForm: {
          search: '',
          time: []
        },
        groupList: [],

        circleOption: {},
      }
    },
    computed: {
      user: getUser
    },
    created() {
      const myDate = new Date()
      const year = myDate.getFullYear()
      let month = myDate.getMonth() + 1
      let day = myDate.getDate()
      month = month > 9 ? month + '' : '0' + month
      day = day > 9 ? day + '' : '0' + day
      this.searchForm.time.push(year + '-' + month + '-01')
      this.searchForm.time.push(year + '-' + month + '-' + day)

      this.getData()
      this.getData2()
    },
    methods: {
      splitStartSort(a, b) {
        let a_tt = a.splitStart || a.allotTime
        let b_tt = b.splitStart || b.allotTime
        if (a_tt && b_tt) {
          return new Date(a_tt).getTime() - new Date(b_tt).getTime()
        }
        return 0
      },
      splitStandardSort(a, b) {
        let a_tt = a.splitStandardTime
        let b_tt = b.splitStandardTime
        if (a_tt && b_tt) {
          return this.getTimeByDays(a_tt) - this.getTimeByDays(b_tt)
        }
        return !a_tt ? -1 : 1
      },
      splitTakeSort(a, b) {
        let a_tt = a.splitTakeTime && a.splitTakeTime != '0秒' ? a.splitTakeTime : a.splitTake
        let b_tt = b.splitTakeTime && b.splitTakeTime != '0秒' ? b.splitTakeTime : b.splitTake
        if (a_tt && b_tt) {
          return this.getTimeByDays(a_tt) - this.getTimeByDays(b_tt)
        }
        return 0
      },
      splitPauseSort(a, b) {
        let a_tt = a.splitPauseTake
        let b_tt = b.splitPauseTake
        if (a_tt && b_tt) {
          return this.getTimeByDays(a_tt) - this.getTimeByDays(b_tt)
        }
        return 0
      },

      // x天x时x分x秒 时间格式 转换为秒数
      getTimeByDays(daysStr) {
        let time = 0
        let tt = daysStr || ''
        if (tt.indexOf('天') > 0) {
          const arr = tt.split('天')
          time += arr[0] * 24 * 3600
          tt = arr.length > 1 ? arr[1] : tt
        }
        if (tt.indexOf('时') > 0) {
          const arr = tt.split('时')
          time += arr[0] * 3600
          tt = arr.length > 1 ? arr[1] : tt
        }
        if (tt.indexOf('分') > 0) {
          const arr = tt.split('分')
          time += arr[0] * 60
          tt = arr.length > 1 ? arr[1] : tt
        }
        if (tt.indexOf('秒') > 0) {
          const arr = tt.split('秒')
          time += arr[0] * 1
        }
        return time
      },

      getData() {
        if (this.loading) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          keyword: this.searchForm.search,
          startTime: startTime,
          endTime: endTime,
          userid: this.user.dUserid
        }
        this.loading = true
        getSplitAnalysis(data).then(response => {
          const data = response.data || {}
          this.analysisData = data

          this.analysisData.ybjTotalNum = (this.analysisData.zdBjNum || 0) + (this.analysisData.kgdBjNum || 0) +
            (this.analysisData.zbdBjNum || 0) + (this.analysisData.sbdBjNum || 0) +
            (this.analysisData.shdBjNum || 0) + (this.analysisData.ggdBjNum || 0)

          this.initCharts(data.financeList, 'finance')
          this.initCharts(data.splitList, 'split')
          this.initCharts(data.orderTypes, 'orderType')
          this.initCharts(data.zCdDays, 'zCd')
          this.initCharts(data.bCdDays, 'bCd')
          this.initCharts(data.zfCdDays, 'zfCd')
          this.initCharts(data.bfCdDays, 'bfCd')

          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },

      getData2() {
        if (this.loading2) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        this.loading2 = true
        getSplitData().then(response => {
          const data = response.data || {}
          this.splitData = data

          const base = 90000
          const base2 = 65000
          let list = [{
            mark: 4,
            name: '技术评估',
            num: this.splitData.jspg,
            priceTotal: this.splitData.jspg * base
          }, {
            mark: 5,
            name: '订单分配',
            num: this.splitData.cdfp,
            priceTotal: this.splitData.cdfp * base
          }, {
            mark: 6,
            name: '拆单中',
            num: this.splitData.cdz,
            priceTotal: this.splitData.cdz * base
          }, {
            name: '在线未完成合计',
            num: this.splitData.jspg + this.splitData.cdfp + this.splitData.cdz,
            priceTotal: (this.splitData.jspg + this.splitData.cdfp + this.splitData.cdz) * base
          }, {
            mark: 88,
            name: '审单中',
            num: this.splitData.sdz,
            priceTotal: this.splitData.sdz * base2
          }, {
            mark: 7,
            name: '订单确认',
            num: this.splitData.ddqr,
            priceTotal: this.splitData.ddqr * base2
          }, {
            mark: 8,
            name: '待报价',
            num: this.splitData.dbj,
            priceTotal: this.splitData.dbj * base2
          }, {
            mark: 9,
            name: '已报价',
            num: this.splitData.ybj,
            priceTotal: this.splitData.ybjje
          }, {
            name: '本月已拆单完成',
            num: this.splitData.bywc,
            priceTotal: this.splitData.ybjje + (this.splitData.sdz + this.splitData.ddqr + this.splitData.dbj) * base2
          }, {
            name: '总合计',
            num: this.splitData.ybj,
            priceTotal: this.splitData.ybjje + (this.splitData.sdz + this.splitData.ddqr + this.splitData.dbj) * base2 + (this.splitData.jspg + this.splitData.cdfp + this.splitData.cdz) * base
          }]
          this.splitData.tableData = list

          let chartsData = []
          this.splitData.tableData.forEach(r => {
            if (r.mark) {
              chartsData.push({
                ...r,
                scaleTotal: r.priceTotal
              });
            }
          });
          this.initCharts(chartsData, 'sd')

          this.loading2 = false
        }).catch(() => {
          this.loading2 = false
        })
      },

      initCharts(list, type) {
        let circleData = []

        for (const item of list) {
          circleData.push({
            name: item.name,
            y: item.scaleTotal
          })
        }

        const circle = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: false,
          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.2f} %'
              }
            }
          },
          series: [{
            name: '占比',
            colorByPoint: true,
            data: circleData
          }]
        }

        if (type) {
          this.circleOption[`${type}`] = circle
        }
      },

      handleSizeChange(val) {
        this.viewPage.pageSize = val
        this.getDetailData()
      },
      handleCurrentChange(val) {
        this.viewPage.currentPage = val
        this.getDetailData()
      },

      tableCellClassName({row, rowIndex}) {
        // console.log(row)
        if (row.name === '在线未完成合计') {
          return 'error-row';
        } else if (row.name === '本月已拆单完成') {
          return 'warning-row';
        } else if (row.name === '总合计') {
          return 'success-row';
        }
        return '';
      },
      // 弹窗信息
      seeSplitDetail(row) {
        this.orderVisible2 = true

        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          keyword: this.searchForm.search,
          startTime: startTime,
          endTime: endTime,
          name: row.name,
          userid: this.user.dUserid
        }
        this.orderLoading2 = true
        this.viewTitle2 = ''
        this.orderList2 = []
        getSplitAnalysisDetail(data).then(response => {
          const data = response.data || []
          this.orderList2 = data
          this.orderLoading2 = false
          this.viewTitle2 = row.name + ' - 拆单详情 (共 ' + this.orderList2.length + ' 单)'
        }).catch(() => {
          this.orderLoading2 = false
        })
      },
      // 弹窗信息
      seeOrders(row) {
        this.orderVisible = true
        if (row.mark == 9) {
          this.orderList = this.splitData.offerOrders || []
        } else {
          this.orderList = (this.splitData.splitOrders || []).filter(r => r.mark == row.mark)
        }
        this.viewTitle = row.name + ' - 订单列表 (共 ' + this.orderList.length + ' 单)'
      },
      openDetails(row) {
        if (row.orderId.length > 36) {
          this.$router.push({
            path: '/work/order/' + row.orderId.substring(0, 36),
            query: {
              data: row.orderId.substring(37)
            }
          })
        } else {
          this.$router.push({ path: '/work/order/' + row.orderId.substring(0, 36) })
        }
        this.orderVisible = false
        this.orderVisible2 = false
      },

      exportExcelAll() {
        if (!this.excelLoading) {
          this.excelLoading = true
          let startTime = ''
          let endTime = ''
          if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
            startTime = this.searchForm.time[0]
            endTime = this.searchForm.time[1]
          }
          const data = {
            startTime: startTime,
            endTime: endTime,
            userid: this.user.dUserid
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          excelSplitAnalysis(data).then(response => {
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.dPath, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName + '.' + response.data.dType
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', {
                    attrs: {
                      style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;'
                    }
                  }, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a', {
                      attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }
                    }, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {})
              }
            }
            xhr.send()
            this.excelLoading = false
          }).catch(() => {
            this.excelLoading = false
          })
        }
      },

    }
  }
</script>

<style>
  .el-table .warning-row {
    background: #faecd8 !important;
  }

  .el-table .error-row {
    background: #fde2e2 !important;
  }

  .el-table .success-row {
    background: #e1f3d8 !important;
  }
</style>
